import { render, staticRenderFns } from "./editCollection.vue?vue&type=template&id=e1755298&scoped=true"
import script from "./editCollection.vue?vue&type=script&lang=js"
export * from "./editCollection.vue?vue&type=script&lang=js"
import style0 from "./editCollection.vue?vue&type=style&index=0&id=e1755298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1755298",
  null
  
)

export default component.exports